// dependencies
import { CreateProcess } from "redux-process";

// eslint-disable-next-line import/prefer-default-export
export const MfaAuthenticate = CreateProcess({
	method: "POST",
	name: "MfaAuthenticate",
	type: "USERS:GET",

	request: (props) => ({
		url: "/auth/mfa-login/",
		payload: props.payload,
	}),

	success: (response) => ({
		isValid: response.data.valid,
		jwtPayload: response.data.payload,
	}),

	error: () => ({ error: "Unauthorized", actionMessage: "Dismiss" }),
});
